<template>
  <v-row>
    <v-col cols="12">
      <Title :titlePage="titlePage" />
    </v-col>

    <v-container>
      <ProjetDetail
        v-if="mode === 'visualisation'"
        :projet="projet"
        :utilisateurs="utilisateurs"
      />
      <ProjetForm
        v-else
        :projet="projet"
        :utilisateurs="utilisateurs"
        @emitProjet="createOrUpdateProjet"
        @closeRappel="closeRappel"
      />
    </v-container>
  </v-row>
</template>
<script>
import Title from "@/components/shared/Title";
import ProjetForm from "@/components/Clients/ProjetForm";
import ProjetDetail from "@/components/Clients/ProjetDetail";

import api from "@/api/projet";
import api_doc from "@/api/document";
import api_rappels from "@/api/rappel";
import api_user from "@/api/user";

export default {
  components: {
    Title,
    ProjetForm,
    ProjetDetail,
  },
  data() {
    return {
      projet: {
        id_projet: null,
        nom_projet: "",
        date_projet: "",
        description: "",
        commentaire_projet_obtenu: "",
        projet_obtenu: null,
        bloc_fore: false,
        application: "",
        fonctionnement_bloc: "",
        debit_max: "",
        pression_max: "",
        protection: "",
        qte_annuelle: "",
        qte_livraison: "",
        prix_objectif: "",
        etapes: [],
        outils_specifiques: [],
        outils_specifiques_keys: [],
        cartouches_non_stockees: [],
        cartouches_non_stockees_keys: [],
        showOutilsForm: false,
        showCartouchesForm: false,
        id_utilisateur: this.$store.state.user.id_utilisateur,
        rappels: [],
        rows: [],
        projet_a_articles: [],
        document: {
        },
        documents: {
          mails_importants: [],
          schemas_hydrauliques: [],
          photos: [],
          offres_fournisseur: [],
          _3d_2d: [],
          autres: [],
        },
        commentaires: [],
        personnes: [],
        commentaire_: "",
      },
      rappel: {
        urgent: false,
        date_rappel: "",
        commentaire: "",
      },
      utilisateurs: [],
      titlePage: "NOUVEAU PROJET",
      mode: "creation",
    };
  },

  methods: {


    closeRappel(rappel) {
      api_rappels.closeRappel(rappel.id_rappel).then(() => {
          api.getRappelsProjet(this.$route.params.id_entreprise, this.$route.params.id_projet).then((res) => {
            this.projet.rappels = res.data.rappels
          }).catch(() => {
            this.$store.dispatch('notify', { message: 'Erreur lors du chargement' });
          });
      }).catch(() => {
        this.$store.dispatch('notify', { message: 'Erreur lors de la mise à jour' });
      });
    },

    // The API expects each chemin under uploads/<id_entreprise>/projets/<id_projet>/.
    // New projects only know the folder-relative chemin (e.g. /photos/file.pdf).
    uploadProjectDocuments(id_projet, documentsPayload) {
      if (!documentsPayload || documentsPayload.uploads.length === 0) {
        return;
      }
      const id_entreprise = this.$route.params.id_entreprise;
      const projectRoot = `uploads/${id_entreprise}/projets/${id_projet}`;
      const uploads = documentsPayload.uploads.map((upload) => {
        const relative = upload.chemin
          .replace(process.env.VUE_APP_BASE_URL, '')
          .replace(/^\/?uploads\/[^/]+\/projets\/[^/]+/, '')
          .replace(/^\/?/, '/');
        return { ...upload, chemin: projectRoot + relative };
      });
      api_doc.uploadProjectDocuments(id_entreprise, id_projet, { uploads })
        .catch(() => {
          this.$store.dispatch('notify', { message: 'Erreur lors de l\'enregistrement' });
        });
    },

    // Back to the client page on the PROJETS tab (index 1 in Client.vue)
    goToProjetsTab() {
      this.$store.commit('changeOnglet', 1);
      this.$router.push({ name: 'client', params: { id_entreprise: this.$route.params.id_entreprise } });
    },

    createOrUpdateProjet({ projet, documentsPayload }) {
      if (this.mode === "creation") {
        api.createProjet(projet).then((res) => {
          const id_projet = res.data.projet.id_projet;

          this.uploadProjectDocuments(id_projet, documentsPayload);

          this.$store.dispatch('notify', { message: 'Projet sauvegardé', type: 'success' });
          this.goToProjetsTab();
        }).catch(() => {
          this.$store.dispatch('notify', { message: 'Erreur lors de l\'enregistrement' });
        });
      } else if (this.mode === "modification") {
        api.updateProjet(projet).then(() => {
          const id_projet = projet.id_projet;

          this.uploadProjectDocuments(id_projet, documentsPayload);

          this.$store.dispatch('notify', { message: 'Projet mis à jour', type: 'success' });
          this.goToProjetsTab();
        }).catch(() => {
          this.$store.dispatch('notify', { message: 'Erreur lors de l\'enregistrement' });
        });
      }
    },

    // The bloc plan is the most recent image or PDF in the project's photos/ folder.
    loadBlocImage(id_projet) {
      api_doc.getProjectDocuments(id_projet).then((res) => {
        const children = typeof res.data.children === 'string' ? JSON.parse(res.data.children) : res.data.children;
        const photos = (children || []).find((folder) => folder.name === 'photos');
        const images = (photos ? photos.files : [])
          .filter((file) => /\.(png|jpe?g|gif|webp|bmp|svg|pdf)$/i.test(file.name))
          .sort((a, b) => new Date(b.lastModified) - new Date(a.lastModified));
        this.projet.document = images.length > 0 ? images[0] : null;
      }).catch(() => {
        this.projet.document = null;
      });
    },

    getProjet(id_projet) {
      api.getProjet(id_projet).then((res) => {
        this.projet.id_projet = res.data.projet[0].id_projet;
        this.projet.nom_projet = res.data.projet[0].nom_projet;
        this.projet.date_projet = res.data.projet[0].date_projet;
        this.projet.description = res.data.projet[0].description;
        this.projet.commentaire_projet_obtenu =res.data.projet[0].commentaire_projet_obtenu;
        this.projet.projet_obtenu = res.data.projet[0].projet_obtenu;

        this.projet.bloc_fore = res.data.projet[0].bloc_fore;
        this.projet.application = res.data.projet[0].application;
        this.projet.fonctionnement_bloc = res.data.projet[0].fonctionnement_bloc;
        this.projet.debit_max = res.data.projet[0].debit_max;
        this.projet.pression_max = res.data.projet[0].pression_max;
        this.projet.protection = res.data.projet[0].protection;
        this.projet.matiere_utilisee = res.data.projet[0].matiere_utilisee;
        this.projet.recurrence_fabrication = res.data.projet[0].recurrence_fabrication;
        this.projet.tension = res.data.projet[0].tension;
        this.projet.connecteurs = res.data.projet[0].connecteurs;
        this.projet.type_connecteur = res.data.projet[0].type_connecteur;
        this.projet.qte_annuelle = res.data.projet[0].qte_annuelle;
        this.projet.qte_livraison = res.data.projet[0].qte_livraison;
        this.projet.prix_objectif = res.data.projet[0].prix_objectif;

        this.projet.reglage_pression = res.data.projet[0].reglage_pression;
        this.projet.frequence_test = res.data.projet[0].frequence_test;
        this.projet.longueur = res.data.projet[0].bloc_longueur;
        this.projet.largeur = res.data.projet[0].bloc_largeur;
        this.projet.hauteur = res.data.projet[0].bloc_hauteur;
        this.projet.face_6 = res.data.projet[0].face_6;

        const faces = JSON.parse(res.data.projet[0].faces);

        this.projet.rows = (
          faces === null ||
          faces === 'null' ||
          (Array.isArray(faces) && faces.length === 0) ||
          faces === '' ||
          faces === undefined ||
          faces === 'undefined'
        ) ? null : faces;

        this.projet.projet_a_articles = res.data.projet[0].articles;

        this.projet.personnes = res.data.projet[0].Personnes;
        this.projet.rappels = res.data.projet[0].Rappels;
        this.projet.id_utilisateur = res.data.projet[0].id_utilisateur;

        this.loadBlocImage(id_projet);

        this.projet.commentaires = res.data.projet[0].Commentaires.sort(function (a, b) {
          return a.id_commentaire - b.id_commentaire;
        });
      }).catch((e) => {
        console.error('[ProjetEntreprise] getProjet failed:', e);
        this.$store.dispatch('notify', { message: 'Erreur lors du chargement' });
      });
    },
  },
  created() {
    api.getEtapesProjetBlocFore(this.$route.params.id_projet).then((res) => {
      if (!res) { return; }
      this.projet.etapes = res.data.etapes;
      this.projet.outils_specifiques = res.data.outils_specifiques;
      this.projet.cartouches_non_stockees = res.data.cartouches;
      this.projet.outils_specifiques_keys = Object.keys(res.data.outils_specifiques[0]).splice(2);
      this.projet.cartouches_non_stockees_keys = Object.keys(res.data.cartouches[0]).splice(2);
      this.projet.showOutilsForm = this.projet.etapes.some(obj => obj.id === 6 && obj.isChecked === true);
      this.projet.showCartouchesForm = this.projet.etapes.some(obj => obj.id === 7 && obj.isChecked === true);
    }).catch((e) => {
      console.error('[ProjetEntreprise] getEtapesProjetBlocFore failed:', e);
      this.$store.dispatch('notify', { message: 'Erreur lors du chargement' });
    });
    api_user.getCommerciaux().then((res) => {
      this.utilisateurs = res.data.users;
    }).catch((e) => {
      console.error('[ProjetEntreprise] getCommerciaux failed:', e);
      this.$store.dispatch('notify', { message: 'Erreur lors du chargement' });
    });
    if (this.$route.name === "update_projet") {
      this.titlePage = "MODIFIER UN PROJET";
      this.mode = "modification";
      this.getProjet(this.$route.params.id_projet);
    }

    if (this.$route.name === "view_projet") {
      this.titlePage = "VOIR UN PROJET";
      this.mode = "visualisation";
      this.getProjet(this.$route.params.id_projet);
    }
  },
};
</script>
<style>
</style>
